import { ca } from '@cian/analytics';

import { type TCianApiSiteV1GetUserDataByRequestResponse_1 } from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

interface IProduct {
  id: number;
  offerType: 'offer';
  position: number;
  extra?: { is_viewes: boolean };
}

interface ITrackPageViewCollectParams {
  products: IProduct[];
  user?: TCianApiSiteV1GetUserDataByRequestResponse_1['data']['user'] | null;
}

export const trackPageViewCollect = ({ products, user }: ITrackPageViewCollectParams): void => {
  return ca('event', {
    action: 'show_sopr',
    category: 'seen_label',
    name: 'oldevent',
    page: {
      pageType: 'ListingHybrid',
      siteType: 'desktop',
    },
    products,
    user: user?.isAuthenticated ? { userId: user.id } : {},
  });
};
